import React, { useEffect } from "react";
import { Offcanvas, Table } from "react-bootstrap";
import { MdRestore } from "react-icons/md";
import { NoDataFoundTable, PageLoader } from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";
import Pagination from "../../../../Pagination";

const DeletedSubject = ({ tableRef, onMouseDown, subjectDeletedRows, softDeleteRestoreStudySubjectRow, Show, Hide, Title, siteId, getDeletedStudySubjectRowData, subjectDeletedRowsCount, pageNumberDeleted, itemsPerPageDeleted, setPageNumberDeleted, setItemsPerPageDeleted, deletedSubjectLoader }) => {
  const startIndex = (pageNumberDeleted - 1) * itemsPerPageDeleted;
  const totalPage = Math.ceil(subjectDeletedRowsCount / itemsPerPageDeleted);
  useEffect(() => {
    getDeletedStudySubjectRowData(pageNumberDeleted, itemsPerPageDeleted)
  }, [siteId, pageNumberDeleted, itemsPerPageDeleted]);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton >
          <Offcanvas.Title
          >
            {Title}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          {deletedSubjectLoader ? 
           <PageLoader/>
          : subjectDeletedRows?.length === 0 ? (
            <div className="hstack justify-content-center h-100">
              <NoDataFoundTable MSG={"Subject not deleted yet."} />
            </div>
          ) :
            <>
              <Table className="m-0 custom-table" hover striped ref={tableRef}>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>
                      Subject Id
                    </th>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 2)}
                      style={{ width: 80 }}
                      className="text-center"
                    >
                      Void Restore
                    </th>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 2)}
                      style={{ width: 55 }}
                      className="text-center"
                    >
                      Restore
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {subjectDeletedRows?.map((row, index) => (
                    <tr
                      key={index}
                      title="View Details"
                    >
                      <td className="text-center">{index + 1 + startIndex}</td>
                      <td>{row?.row?.["SUBJECTID"] || row?.row?.["RANDOMNUMBER"] || row?.row?.["SCREENID"] }</td>
                      <td className="text-center" title="Restore">
                        <MdRestore style={{ fontSize: 16 }} onClick={(e) => softDeleteRestoreStudySubjectRow(row?.subjectId, "restore", row?.siteId, true)} className="text-success CP" />
                      </td>
                      <td className="text-center" title="Restore">
                        <MdRestore style={{ fontSize: 16 }} onClick={(e) => softDeleteRestoreStudySubjectRow(row?.subjectId, "restore", row?.siteId, false)} className="text-success CP" />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumberDeleted}
                  itemsPerPage={itemsPerPageDeleted}
                  totalItems={subjectDeletedRowsCount}
                  setPageNumber={setPageNumberDeleted}
                  setItemsPerPage={setItemsPerPageDeleted}
                />
              </div>
            </>
          }
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default DeletedSubject;
